import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

const processOccupationData = (data) => {
  if (!data) return data;

  const processItem = (item) => {
    if (!item) return item;
    if (item.ocupation) {
      const occupationValue = parseFloat(item.ocupation.replace("%", ""));
      item.ocupation = `${Number(occupationValue).toFixed(1)} %`;
    }
    return item;
  };

  return {
    ...data,
    above_mean: data.table_data?.above_mean?.map(processItem),
    below_mean: data.table_data?.below_mean?.map(processItem),
  };
};

export default function useProcessedDataFlowDetections({
  start_datetime,
  end_datetime,
  date,
  zones,
  collections,
  enabled = true,
}) {
  const { getProcessedData } = useApi();

  const {
    data: processedData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [
      "processed-data-flow-detections",
      start_datetime,
      end_datetime,
      date,
      zones,
      collections,
    ],
    queryFn: () =>
      getProcessedData({
        start_datetime,
        end_datetime,
        date,
        zones,
        collections,
      }),
    select: (response) => {
      const data = response?.data;
      if (!data) return null;

      const bargraphData = {
        labels: [],
        datasets: [],
      };

      if (data?.bargraph_data) {
        const zones = data.bargraph_data;
        const labels = zones?.map((item) => item.description);
        const permanenceData = zones?.map((item) => {
          if (!item?.permanence) return 0;
          return parseFloat(item.permanence.replace("min", "")) || 0;
        });

        if (
          labels &&
          permanenceData &&
          labels?.length === permanenceData?.length
        ) {
          const combined = labels?.map((label, index) => ({
            label: label,
            data: permanenceData[index],
          }));
          combined.sort((a, b) => b.data - a.data);

          const sortedLabels = combined.map((item) => item.label);
          const sortedData = combined.map((item) => item.data);

          bargraphData.labels = sortedLabels;
          bargraphData.datasets = [
            {
              label: "Tempo de Permanência (min)",
              data: sortedData,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          ];
        }
      }

      return {
        ...processOccupationData(data),
        bargraphData,
        maxZonesBarChart: data?.bargraph_data?.length || 0,
      };
    },
    enabled: Boolean(enabled),
  });

  return { data: processedData, isLoading, refetch };
}
